import _ from 'underscore';
import { getDefaultTimeRange } from './default-time-ranges';
import { getAllowedRanges } from './time-grain-range-options';

// if `prevTimeRange` is not allowed in new options, return default new one
// Otherwise return `prevTimeRange`
export function tryGetUpdatedTimeRange({
  newTimeGrain, prevTimeGrain, prevTimeRange, reportSchema,
}) {
  let newTimeRange = prevTimeRange;
  if (newTimeGrain !== prevTimeGrain) {
    const prevTimeRangeKey = prevTimeRange.key;
    const allowedRanges = getAllowedRanges(newTimeGrain, reportSchema);
    if (!_.contains(allowedRanges, prevTimeRangeKey)) {
      const defaultTimeRange = getDefaultTimeRange(newTimeGrain, reportSchema);
      newTimeRange = {
        key: defaultTimeRange || allowedRanges[0],
      };
    }
  }
  // TODO: How do we change timezone?
  return newTimeRange;
}
